import React from 'react';
import { capitalize } from 'lodash';

import Caption from '~/components/core/TextComponents/Caption';
import Text from '~/components/core/TextComponents/Text';
import { usePaymentsConfiguration } from '~/components/hooks/usePaymentsConfiguration';
import type { ContactFullModel } from '~/server_shared/swagger/data-contracts';

interface Form1099PropsType {
  contact: ContactFullModel;
}

const Form1099: React.FC<Form1099PropsType> = ({ contact }) => {
  const { show1099Fields } = usePaymentsConfiguration();

  if (contact.country !== 'US' || !show1099Fields || typeof contact.is_1099_reportable !== 'boolean') {
    return null;
  }

  return (
    <div className="col-span-full mt-12 grid grid-cols-2">
      <div>
        <Caption variant={Caption.VARIANTS.LABEL}>Is 1099 Reportable?</Caption>
        <Text weight={Text.WEIGHTS.REGULAR} variant={Text.VARIANTS.SM}>
          {contact.is_1099_reportable ? 'Reportable' : 'Not Reportable'}
        </Text>
      </div>
      {contact.is_1099_reportable ? (
        <div>
          <Caption variant={Caption.VARIANTS.LABEL}>Report Type</Caption>
          <Text weight={Text.WEIGHTS.REGULAR} variant={Text.VARIANTS.SM}>
            {capitalize(contact.report_type_1099)}
          </Text>
        </div>
      ) : null}
    </div>
  );
};

export default Form1099;
